import { render, staticRenderFns } from "./IsUse.vue?vue&type=template&id=4467b480&scoped=true"
import script from "./IsUse.vue?vue&type=script&lang=js"
export * from "./IsUse.vue?vue&type=script&lang=js"
import style0 from "./IsUse.vue?vue&type=style&index=0&id=4467b480&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467b480",
  null
  
)

export default component.exports